export default [
    {
        path: '/ccpa',
        name: 'mha.affiliates.ccpa',
        components: {
            default: () => import(/* webpackChunkName: "evergreen.ccpa" */ '@/modules/affiliates/ccpa/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "evergreen.ccpa" */ '@/modules/affiliates/components/the-footer.vue')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerLogos: [
                {
                    href: 'https://www.ccpa-accp.ca/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/ccpa/ccpa-logo.png',
                    imgAlt: 'CCPA Logo',
                    style: 'width:185px;'
                }
            ],
            isCcpa: true,
            initCountry: 'Canada'
        },
    },
    {
        path: '/cce',
        name: 'mha.affiliates.cce',
        components: {
            default: () => import(/* webpackChunkName: "evergreen.cce" */ '@/modules/affiliates/cce/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "evergreen.cce" */ '@/modules/affiliates/components/the-footer.vue')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerLogos: [
                {
                    href: 'https://www.cce-global.org/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/affiliates/cce.jpg',
                    imgAlt: 'CCE Logo',
                    style: 'width:185px;'
                }
            ],
            initCountry: 'United States'
        },
    }
]